/**
 * The console's own appearance vocabulary — light or dark, the four palettes and the six accents —
 * with no side effects, so pure modules (`look.ts`, `look-data.ts`) and their tests can name them
 * without importing `theme.ts`, whose stores write to <html> the moment they load. `theme.ts`
 * re-exports all of it and remains where the reasons are written down.
 */
export type Theme = 'light' | 'dark';

/** See `theme.ts`: the vocabulary exists four times and that file's comment says which one leads. */
export type Palette = 'thunder' | 'slate' | 'stone' | 'zinc';

/** For the organisation's Appearance tab, in the order it should offer them. */
export const PALETTES: ReadonlyArray<{ id: Palette; label: string }> = [
  { id: 'thunder', label: 'Thunder' },
  { id: 'slate', label: 'Slate' },
  { id: 'stone', label: 'Stone' },
  { id: 'zinc', label: 'Zinc' },
];

/** See `theme.ts`: ordered by clearance from the colours that mean something, not by taste. */
export type Accent = 'lime' | 'orange' | 'violet' | 'citron' | 'magenta' | 'teal';

export const ACCENTS: ReadonlyArray<{ id: Accent; label: string }> = [
  { id: 'lime', label: 'Lime' },
  { id: 'citron', label: 'Citron' },
  { id: 'teal', label: 'Teal' },
  { id: 'violet', label: 'Violet' },
  { id: 'magenta', label: 'Magenta' },
  { id: 'orange', label: 'Orange' },
];
